module.exports = __webpack_public_path__ + "static/media/AD.065290de.png";